/* eslint-disable */
import Long from 'long';
import * as _m0 from 'protobufjs/minimal';

export const protobufPackage = 'od_protos.journey.data';

/** Next ID: 3 */
export interface AccordionClickEvent {
  /**
   * Canonical identifier of the accordion list
   * Convention: {app_name}-{accordion_list_name}
   * accordion_list_name should be unique within the app
   */
  targetName: string;
  /** Name of the individual accordion in the accordion list */
  accordionName: string;
}

/** Next ID: 3 */
export interface AccordionHoverEvent {
  /**
   * Canonical identifier of the accordion list
   * Convention: {app_name}-{accordion_list_name}
   * accordion_list_name should be unique within the app
   */
  targetName: string;
  /** Name of the individual accordion in the accordion list */
  accordionName: string;
}

/** Next ID: 3 */
export interface AccordionViewEvent {
  /**
   * Canonical identifier of the accordion list
   * Convention: {app_name}-{accordion_list_name}
   * accordion_list_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface BoxViewEvent {
  /**
   * Canonical identifier of the box
   * Convention: {app_name}-{box_name}
   * box_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface ButtonClickEvent {
  /**
   * Canonical identifier of the button
   * Convention: {app_name}-{button_name}
   * button_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface ButtonHoverEvent {
  /**
   * Canonical identifier of the button
   * Convention: {app_name}-{button_name}
   * button_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface ButtonViewEvent {
  /**
   * Canonical identifier of the button
   * Convention: {app_name}-{button_name}
   * button_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface CardViewEvent {
  /**
   * Canonical identifier of the card
   * Convention: {app_name}-{card_name}
   * card_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 3 */
export interface CheckboxClickEvent {
  /**
   * Canonical identifier of the checkbox group
   * Convention: {app_name}-{checkbox_name}
   * checkbox_name should be unique within the app
   */
  targetName: string;
  /** Name of the individual checkbox in the checkbox group */
  optionName: string;
}

/** Next ID: 3 */
export interface CheckboxHoverEvent {
  /**
   * Canonical identifier of the checkbox group
   * Convention: {app_name}-{checkbox_name}
   * checkbox_name should be unique within the app
   */
  targetName: string;
  /** Name of the individual checkbox in the checkbox group */
  optionName: string;
}

/** Next ID: 2 */
export interface CheckboxViewEvent {
  /**
   * Canonical identifier of the checkbox group
   * Convention: {app_name}-{checkbox_name}
   * checkbox_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 12 */
export interface ExternalLeadGeneratedEvent {
  leadSource: string;
  firstName?: string;
  middleName?: string;
  lastName?: string;
  email?: string;
  addressLine1?: string;
  addressLine2?: string;
  city?: string;
  state?: string;
  postalCode?: string;
  leadProperties: { [key: string]: string };
}

export interface ExternalLeadGeneratedEvent_LeadPropertiesEntry {
  key: string;
  value: string;
}

/** Next ID: 2 */
export interface ImageViewEvent {
  /**
   * Canonical identifier of the image
   * Convention: {app_name}-{image_name}
   * image_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface InputBlurEvent {
  /**
   * Canonical identifier of the input
   * Convention: {app_name}-{input_name}
   * input_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface InputFocusEvent {
  /**
   * Canonical identifier of the input
   * Convention: {app_name}-{input_name}
   * input_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface InputHoverEvent {
  /**
   * Canonical identifier of the input
   * Convention: {app_name}-{input_name}
   * input_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface InputViewEvent {
  /**
   * Canonical identifier of the input
   * Convention: {app_name}-{input_name}
   * input_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface LinkClickEvent {
  /**
   * Canonical identifier of the link
   * Convention: {app_name}-{link_name}
   * link_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface LinkHoverEvent {
  /**
   * Canonical identifier of the link
   * Convention: {app_name}-{link_name}
   * link_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface LinkViewEvent {
  /**
   * Canonical identifier of the link
   * Convention: {app_name}-{link_name}
   * link_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 3 */
export interface OutreachEvent {
  eventType: string;
  bucket: string;
}

/**
 * website_source field contains the page's url, etc.
 * No other event-specific data needed for now.
 * Next ID: 1
 */
export interface PageViewEvent {}

/** Next ID: 3 */
export interface RadioClickEvent {
  /**
   * Canonical identifier of the radio group
   * Convention: {app_name}-{radio_name}
   * radio_name should be unique within the app
   */
  targetName: string;
  /** Name of the individual radio in the radio group */
  optionName: string;
}

/** Next ID: 2 */
export interface RadioHoverEvent {
  /**
   * Canonical identifier of the radio group
   * Convention: {app_name}-{radio_name}
   * radio_name should be unique within the app
   */
  targetName: string;
  /** Name of the individual radio in the radio group */
  optionName: string;
}

/** Next ID: 3 */
export interface RadioViewEvent {
  /**
   * Canonical identifier of the radio group
   * Convention: {app_name}-{radio_name}
   * radio_name should be unique within the app
   */
  targetName: string;
}

/** Next ID: 2 */
export interface TextViewEvent {
  /**
   * Canonical identifier of the text
   * Convention: {app_name}-{text_name}
   * text_name should be unique within the app
   */
  targetName: string;
}

function createBaseAccordionClickEvent(): AccordionClickEvent {
  return { targetName: '', accordionName: '' };
}

export const AccordionClickEvent = {
  fromJSON(object: any): AccordionClickEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
      accordionName: isSet(object.accordionName) ? String(object.accordionName) : '',
    };
  },

  toJSON(message: AccordionClickEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    message.accordionName !== undefined && (obj.accordionName = message.accordionName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<AccordionClickEvent>, I>>(
    object: I,
  ): AccordionClickEvent {
    const message = createBaseAccordionClickEvent();
    message.targetName = object.targetName ?? '';
    message.accordionName = object.accordionName ?? '';
    return message;
  },
};

function createBaseAccordionHoverEvent(): AccordionHoverEvent {
  return { targetName: '', accordionName: '' };
}

export const AccordionHoverEvent = {
  fromJSON(object: any): AccordionHoverEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
      accordionName: isSet(object.accordionName) ? String(object.accordionName) : '',
    };
  },

  toJSON(message: AccordionHoverEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    message.accordionName !== undefined && (obj.accordionName = message.accordionName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<AccordionHoverEvent>, I>>(
    object: I,
  ): AccordionHoverEvent {
    const message = createBaseAccordionHoverEvent();
    message.targetName = object.targetName ?? '';
    message.accordionName = object.accordionName ?? '';
    return message;
  },
};

function createBaseAccordionViewEvent(): AccordionViewEvent {
  return { targetName: '' };
}

export const AccordionViewEvent = {
  fromJSON(object: any): AccordionViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: AccordionViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<AccordionViewEvent>, I>>(object: I): AccordionViewEvent {
    const message = createBaseAccordionViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseBoxViewEvent(): BoxViewEvent {
  return { targetName: '' };
}

export const BoxViewEvent = {
  fromJSON(object: any): BoxViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: BoxViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<BoxViewEvent>, I>>(object: I): BoxViewEvent {
    const message = createBaseBoxViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseButtonClickEvent(): ButtonClickEvent {
  return { targetName: '' };
}

export const ButtonClickEvent = {
  fromJSON(object: any): ButtonClickEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: ButtonClickEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<ButtonClickEvent>, I>>(object: I): ButtonClickEvent {
    const message = createBaseButtonClickEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseButtonHoverEvent(): ButtonHoverEvent {
  return { targetName: '' };
}

export const ButtonHoverEvent = {
  fromJSON(object: any): ButtonHoverEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: ButtonHoverEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<ButtonHoverEvent>, I>>(object: I): ButtonHoverEvent {
    const message = createBaseButtonHoverEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseButtonViewEvent(): ButtonViewEvent {
  return { targetName: '' };
}

export const ButtonViewEvent = {
  fromJSON(object: any): ButtonViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: ButtonViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<ButtonViewEvent>, I>>(object: I): ButtonViewEvent {
    const message = createBaseButtonViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseCardViewEvent(): CardViewEvent {
  return { targetName: '' };
}

export const CardViewEvent = {
  fromJSON(object: any): CardViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: CardViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<CardViewEvent>, I>>(object: I): CardViewEvent {
    const message = createBaseCardViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseCheckboxClickEvent(): CheckboxClickEvent {
  return { targetName: '', optionName: '' };
}

export const CheckboxClickEvent = {
  fromJSON(object: any): CheckboxClickEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
      optionName: isSet(object.optionName) ? String(object.optionName) : '',
    };
  },

  toJSON(message: CheckboxClickEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    message.optionName !== undefined && (obj.optionName = message.optionName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<CheckboxClickEvent>, I>>(object: I): CheckboxClickEvent {
    const message = createBaseCheckboxClickEvent();
    message.targetName = object.targetName ?? '';
    message.optionName = object.optionName ?? '';
    return message;
  },
};

function createBaseCheckboxHoverEvent(): CheckboxHoverEvent {
  return { targetName: '', optionName: '' };
}

export const CheckboxHoverEvent = {
  fromJSON(object: any): CheckboxHoverEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
      optionName: isSet(object.optionName) ? String(object.optionName) : '',
    };
  },

  toJSON(message: CheckboxHoverEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    message.optionName !== undefined && (obj.optionName = message.optionName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<CheckboxHoverEvent>, I>>(object: I): CheckboxHoverEvent {
    const message = createBaseCheckboxHoverEvent();
    message.targetName = object.targetName ?? '';
    message.optionName = object.optionName ?? '';
    return message;
  },
};

function createBaseCheckboxViewEvent(): CheckboxViewEvent {
  return { targetName: '' };
}

export const CheckboxViewEvent = {
  fromJSON(object: any): CheckboxViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: CheckboxViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<CheckboxViewEvent>, I>>(object: I): CheckboxViewEvent {
    const message = createBaseCheckboxViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseExternalLeadGeneratedEvent(): ExternalLeadGeneratedEvent {
  return {
    leadSource: '',
    firstName: undefined,
    middleName: undefined,
    lastName: undefined,
    email: undefined,
    addressLine1: undefined,
    addressLine2: undefined,
    city: undefined,
    state: undefined,
    postalCode: undefined,
    leadProperties: {},
  };
}

export const ExternalLeadGeneratedEvent = {
  fromJSON(object: any): ExternalLeadGeneratedEvent {
    return {
      leadSource: isSet(object.leadSource) ? String(object.leadSource) : '',
      firstName: isSet(object.firstName) ? String(object.firstName) : undefined,
      middleName: isSet(object.middleName) ? String(object.middleName) : undefined,
      lastName: isSet(object.lastName) ? String(object.lastName) : undefined,
      email: isSet(object.email) ? String(object.email) : undefined,
      addressLine1: isSet(object.addressLine1) ? String(object.addressLine1) : undefined,
      addressLine2: isSet(object.addressLine2) ? String(object.addressLine2) : undefined,
      city: isSet(object.city) ? String(object.city) : undefined,
      state: isSet(object.state) ? String(object.state) : undefined,
      postalCode: isSet(object.postalCode) ? String(object.postalCode) : undefined,
      leadProperties: isObject(object.leadProperties)
        ? Object.entries(object.leadProperties).reduce<{ [key: string]: string }>(
            (acc, [key, value]) => {
              acc[key] = String(value);
              return acc;
            },
            {},
          )
        : {},
    };
  },

  toJSON(message: ExternalLeadGeneratedEvent): unknown {
    const obj: any = {};
    message.leadSource !== undefined && (obj.leadSource = message.leadSource);
    message.firstName !== undefined && (obj.firstName = message.firstName);
    message.middleName !== undefined && (obj.middleName = message.middleName);
    message.lastName !== undefined && (obj.lastName = message.lastName);
    message.email !== undefined && (obj.email = message.email);
    message.addressLine1 !== undefined && (obj.addressLine1 = message.addressLine1);
    message.addressLine2 !== undefined && (obj.addressLine2 = message.addressLine2);
    message.city !== undefined && (obj.city = message.city);
    message.state !== undefined && (obj.state = message.state);
    message.postalCode !== undefined && (obj.postalCode = message.postalCode);
    obj.leadProperties = {};
    if (message.leadProperties) {
      Object.entries(message.leadProperties).forEach(([k, v]) => {
        obj.leadProperties[k] = v;
      });
    }
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<ExternalLeadGeneratedEvent>, I>>(
    object: I,
  ): ExternalLeadGeneratedEvent {
    const message = createBaseExternalLeadGeneratedEvent();
    message.leadSource = object.leadSource ?? '';
    message.firstName = object.firstName ?? undefined;
    message.middleName = object.middleName ?? undefined;
    message.lastName = object.lastName ?? undefined;
    message.email = object.email ?? undefined;
    message.addressLine1 = object.addressLine1 ?? undefined;
    message.addressLine2 = object.addressLine2 ?? undefined;
    message.city = object.city ?? undefined;
    message.state = object.state ?? undefined;
    message.postalCode = object.postalCode ?? undefined;
    message.leadProperties = Object.entries(object.leadProperties ?? {}).reduce<{
      [key: string]: string;
    }>((acc, [key, value]) => {
      if (value !== undefined) {
        acc[key] = String(value);
      }
      return acc;
    }, {});
    return message;
  },
};

function createBaseExternalLeadGeneratedEvent_LeadPropertiesEntry(): ExternalLeadGeneratedEvent_LeadPropertiesEntry {
  return { key: '', value: '' };
}

export const ExternalLeadGeneratedEvent_LeadPropertiesEntry = {
  fromJSON(object: any): ExternalLeadGeneratedEvent_LeadPropertiesEntry {
    return {
      key: isSet(object.key) ? String(object.key) : '',
      value: isSet(object.value) ? String(object.value) : '',
    };
  },

  toJSON(message: ExternalLeadGeneratedEvent_LeadPropertiesEntry): unknown {
    const obj: any = {};
    message.key !== undefined && (obj.key = message.key);
    message.value !== undefined && (obj.value = message.value);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<ExternalLeadGeneratedEvent_LeadPropertiesEntry>, I>>(
    object: I,
  ): ExternalLeadGeneratedEvent_LeadPropertiesEntry {
    const message = createBaseExternalLeadGeneratedEvent_LeadPropertiesEntry();
    message.key = object.key ?? '';
    message.value = object.value ?? '';
    return message;
  },
};

function createBaseImageViewEvent(): ImageViewEvent {
  return { targetName: '' };
}

export const ImageViewEvent = {
  fromJSON(object: any): ImageViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: ImageViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<ImageViewEvent>, I>>(object: I): ImageViewEvent {
    const message = createBaseImageViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseInputBlurEvent(): InputBlurEvent {
  return { targetName: '' };
}

export const InputBlurEvent = {
  fromJSON(object: any): InputBlurEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: InputBlurEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<InputBlurEvent>, I>>(object: I): InputBlurEvent {
    const message = createBaseInputBlurEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseInputFocusEvent(): InputFocusEvent {
  return { targetName: '' };
}

export const InputFocusEvent = {
  fromJSON(object: any): InputFocusEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: InputFocusEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<InputFocusEvent>, I>>(object: I): InputFocusEvent {
    const message = createBaseInputFocusEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseInputHoverEvent(): InputHoverEvent {
  return { targetName: '' };
}

export const InputHoverEvent = {
  fromJSON(object: any): InputHoverEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: InputHoverEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<InputHoverEvent>, I>>(object: I): InputHoverEvent {
    const message = createBaseInputHoverEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseInputViewEvent(): InputViewEvent {
  return { targetName: '' };
}

export const InputViewEvent = {
  fromJSON(object: any): InputViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: InputViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<InputViewEvent>, I>>(object: I): InputViewEvent {
    const message = createBaseInputViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseLinkClickEvent(): LinkClickEvent {
  return { targetName: '' };
}

export const LinkClickEvent = {
  fromJSON(object: any): LinkClickEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: LinkClickEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<LinkClickEvent>, I>>(object: I): LinkClickEvent {
    const message = createBaseLinkClickEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseLinkHoverEvent(): LinkHoverEvent {
  return { targetName: '' };
}

export const LinkHoverEvent = {
  fromJSON(object: any): LinkHoverEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: LinkHoverEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<LinkHoverEvent>, I>>(object: I): LinkHoverEvent {
    const message = createBaseLinkHoverEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseLinkViewEvent(): LinkViewEvent {
  return { targetName: '' };
}

export const LinkViewEvent = {
  fromJSON(object: any): LinkViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: LinkViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<LinkViewEvent>, I>>(object: I): LinkViewEvent {
    const message = createBaseLinkViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseOutreachEvent(): OutreachEvent {
  return { eventType: '', bucket: '' };
}

export const OutreachEvent = {
  fromJSON(object: any): OutreachEvent {
    return {
      eventType: isSet(object.eventType) ? String(object.eventType) : '',
      bucket: isSet(object.bucket) ? String(object.bucket) : '',
    };
  },

  toJSON(message: OutreachEvent): unknown {
    const obj: any = {};
    message.eventType !== undefined && (obj.eventType = message.eventType);
    message.bucket !== undefined && (obj.bucket = message.bucket);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<OutreachEvent>, I>>(object: I): OutreachEvent {
    const message = createBaseOutreachEvent();
    message.eventType = object.eventType ?? '';
    message.bucket = object.bucket ?? '';
    return message;
  },
};

function createBasePageViewEvent(): PageViewEvent {
  return {};
}

export const PageViewEvent = {
  fromJSON(_: any): PageViewEvent {
    return {};
  },

  toJSON(_: PageViewEvent): unknown {
    const obj: any = {};
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<PageViewEvent>, I>>(_: I): PageViewEvent {
    const message = createBasePageViewEvent();
    return message;
  },
};

function createBaseRadioClickEvent(): RadioClickEvent {
  return { targetName: '', optionName: '' };
}

export const RadioClickEvent = {
  fromJSON(object: any): RadioClickEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
      optionName: isSet(object.optionName) ? String(object.optionName) : '',
    };
  },

  toJSON(message: RadioClickEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    message.optionName !== undefined && (obj.optionName = message.optionName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<RadioClickEvent>, I>>(object: I): RadioClickEvent {
    const message = createBaseRadioClickEvent();
    message.targetName = object.targetName ?? '';
    message.optionName = object.optionName ?? '';
    return message;
  },
};

function createBaseRadioHoverEvent(): RadioHoverEvent {
  return { targetName: '', optionName: '' };
}

export const RadioHoverEvent = {
  fromJSON(object: any): RadioHoverEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
      optionName: isSet(object.optionName) ? String(object.optionName) : '',
    };
  },

  toJSON(message: RadioHoverEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    message.optionName !== undefined && (obj.optionName = message.optionName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<RadioHoverEvent>, I>>(object: I): RadioHoverEvent {
    const message = createBaseRadioHoverEvent();
    message.targetName = object.targetName ?? '';
    message.optionName = object.optionName ?? '';
    return message;
  },
};

function createBaseRadioViewEvent(): RadioViewEvent {
  return { targetName: '' };
}

export const RadioViewEvent = {
  fromJSON(object: any): RadioViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: RadioViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<RadioViewEvent>, I>>(object: I): RadioViewEvent {
    const message = createBaseRadioViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

function createBaseTextViewEvent(): TextViewEvent {
  return { targetName: '' };
}

export const TextViewEvent = {
  fromJSON(object: any): TextViewEvent {
    return {
      targetName: isSet(object.targetName) ? String(object.targetName) : '',
    };
  },

  toJSON(message: TextViewEvent): unknown {
    const obj: any = {};
    message.targetName !== undefined && (obj.targetName = message.targetName);
    return obj;
  },

  fromPartial<I extends Exact<DeepPartial<TextViewEvent>, I>>(object: I): TextViewEvent {
    const message = createBaseTextViewEvent();
    message.targetName = object.targetName ?? '';
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin
  ? T
  : T extends Array<infer U>
  ? Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U>
  ? ReadonlyArray<DeepPartial<U>>
  : T extends { $case: string }
  ? { [K in keyof Omit<T, '$case'>]?: DeepPartial<T[K]> } & { $case: T['$case'] }
  : T extends {}
  ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin
  ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & Record<Exclude<keyof I, KeysOfUnion<P>>, never>;

if (_m0.util.Long !== Long) {
  _m0.util.Long = Long as any;
  _m0.configure();
}

function isObject(value: any): boolean {
  return typeof value === 'object' && value !== null;
}

function isSet(value: any): boolean {
  return value !== null && value !== undefined;
}
